import React, { Component } from 'react';
import NavMenu from './NavMenu';

export class Layout extends Component {
  static displayName = Layout.name;

  render() {
    return (
      <React.Fragment >
        <header className="z-40">
          <NavMenu />
        </header>
        {this.props.children}
        <footer className="bg-cruise_darkblue text-lg text-white font-bold p-8">
          <div className="container text-center">
            Welcome to SIMA - your most efficient cruise finder!
          </div>
        </footer>
      </React.Fragment>
    );
  }
}
